/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable  @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react'; // we need this to make JSX
import { Logger } from '../../../libs/utils/logger';
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { getKey, getSessionStorageCustom, isUserLoggedIn, setKey } from '../../../libs/utils/storageManager';
import HttpClient from '../../../libs/utils/httpClient';
import { getLocalStorage, setLocalStorage } from '../../../libs/utils/cacheHandler';
import { getParsedLocalStorage, getUserRefreshProperties, isCsgOrPmPortal, isNullOrUndefined, setVerificationStatus } from '../../Utils/CommonBaseClass';
import { checkPermission, getDefaultCustomer, getRedirectInfo, updateComponentParams } from '../../Utils/CommonBaseClass';
import { useDispatch, useSelector } from 'react-redux';
import { RegisterComponent } from '../../../libs/saga/dataSaga';
import { checkIsPartner } from '../../Utils/ThemeCheckerPartner';
import { getCustomerUrl, setFullStoryProperties, userIdentification } from '../../../libs/utils/utils';
import { DashboardSkeleton } from '../Index/Passport/DashboardSkeleton';
import { applyCustomFeatures } from '../../../libs/services/uiFeatures';
import FxSnackBar from '../../Utils/fx-snack-bar';
import _ from 'lodash';
import FxTopBanner from '../../Utils/fx-top-banner';
import {
    applyNotificationBannerSettings,
    clearNotificationBannerSettingsLoaded,
    MAINTENANCE_BANNER_ID,
} from '../../Utils/fx-top-banner/maintenanceBannerUtils';
import { CustomerType, ThemeEnum } from '../../../types/common.interfaces';


/**
 * Component: KeycloakPostLogin
 * Usage: launch after keycloak login
 */

Logger.debug("Login.tsx", "User logged in KeycloakPostLogin initializing")
const httpClient = HttpClient.getClient();


declare global {
    interface Window {
        README_CONFIG: object;
    }
  }
  const readMeConfig: any = window.README_CONFIG;

export const KeycloakPostLogin: React.FC<any> = (props: any) => {
    ({ props } = RegisterComponent(props));
    const history = useHistory();
    const params = useParams<any>();
    const location = useLocation();
    const dispatch = useDispatch()
    let queryParams: any;
    let customerId:any;
    let customerEmail:any;
    const [userinfo, userDetails] = React.useState<any>();
    const mxmUser=JSON.parse(getLocalStorage('mxmUser'))
    const ssoPath=location?.pathname?.includes('/sso')
    const reloadPath = getSessionStorageCustom('reloadPath');
    const locationState = getSessionStorageCustom('locationState');
    const isUserRefreshed = getSessionStorageCustom("isUserRefreshed");

    /**
     * Method to get selected account from store only when refresh action is done
     */
    const selectedAccount = useSelector((state: any) =>
        state.data['account-list-sub-menu']?.params?.selectedOption
    );

    /**
     * Method used to set key values from session when refreshed
     */
    useEffect(() => {
        isUserRefreshed && getUserRefreshProperties(selectedAccount, dispatch)
    }, [selectedAccount, isUserRefreshed])

    /**
     * UseEffect to load the next page based on account and user permissions
     */
    useEffect(() => {
        applyCustomFeatures(props?.customerConfigurations)
        if (getKey("permissionDenied") === 'True') {
            history.push("user/permission/denied");
        } 
        /**
         * When the user sign the login terms and may api faild for the  Account Agreement then user should redirct to Account Agreement Accepted screen if he login again
         */
    
       
        else if (getParsedLocalStorage('userType')===CustomerType.JOINT_TENANCY && getKey("showTerms") === 'NO' && getKey('accountAgreementAccepted') === false && props?.accountList?.resources?.length>0 ) {
            const payload:any={
                account:props?.accountList?.resources[0],
               
            }
            dispatch({ type: "DATA_COMPONENT_INIT", payload: { id: 'co-owner-aggrement-details' } });
            updateComponentParams(dispatch, 'co-owner-aggrement-details', { 'ownerPayload': payload })
            setLocalStorage('signUpFlow',true);
            history.push('/signup/joint_tenancy_co_owner/kyc')
        }
        else if (getKey("showTerms") === 'YES') {
            history.push("/auth/terms/" + getKey('id'));
        }
        else if(getKey("showTerms") === 'NO' && props.skipSkeleton && props.customerConfigurations) {
            if (isUserLoggedIn() && reloadPath && reloadPath !== '/logout' && isUserRefreshed) {
                updateComponentParams(dispatch, 'customer-home-passport', { 'accountUpdated': true })
                const redirectInfo = getRedirectInfo(props?.accountList, dispatch, reloadPath, selectedAccount, true);
                history.push(locationState ? { pathname: redirectInfo, state: locationState } : redirectInfo);
            }
            else if(checkIsPartner() && (checkPermission({ entity: "Partner Portal", name: "Lead Portal", operation: "View" }))){
                history.push(getRedirectInfo(props?.accountList, dispatch ,'/leads-home'))
            }
            else{
                const signupFlow = getLocalStorage('signUpFlow');
                let customerType;
                try {
                    customerType = getLocalStorage('signupCustomerType')?.replace(/^"|"$/g, '');
                } catch (error) {
                    customerType = null; // or a fallback value like ''
                }
                if (signupFlow==='true') {
                    if (customerType === 'BUSINESS') {
                        history.push('/signup/business/kyc');
                    } else if (customerType === 'INDIVIDUAL') {
                        history.push('/signup/individual/kyc');
                    } else if (customerType === 'JOINT_TENANCY') {
                        const isJTCOwner = getKey('isPrimaryOwner') === false;
                        const url = isJTCOwner ? '/signup/joint_tenancy_co_owner/kyc' : '/signup/joint_tenancy/kyc';
                        history.push(url);
                    }
                } else {
                    history.push(getRedirectInfo(props?.accountList, dispatch, '/dashboard'))
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userinfo, history, props.skipSkeleton, props.customerConfigurations,getKey("showTerms"), getKey('accountAgreementAccepted'), getParsedLocalStorage('userType')])

    /**
     * useEffect to check proxy login token
     */
    useEffect(() => {
        if (ssoPath) {
            setSSOUser()
        }
        else if (params?.token) {
            setProxyUser()
        }
        else {
            getUserInfo();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    /**
     * function to set proxy login value
     */
    const setProxyUser = () => {
        if (params?.token) {
            setLocalStorage('proxyToken', params?.token)
            queryParams = window.atob(params['token']);
        }
        try {
            queryParams = JSON.parse(queryParams)
        } catch (e: any) {
            Logger.error("KeycloakPostLogin.tsx", "error", e);
         }
        setKey("customerId", queryParams?.customerId);
        queryParams?.partnerId && setKey("partnerId", queryParams?.partnerId);
        queryParams?.partnerId && setKey('loginType', 'PARTNER');
        setLocalStorage("isProxyLogin", true);
        setKey("isProxyLogin", true);
        customerId = queryParams?.customerId
        setLocalStorage("permission", 'ADMIN');
        setKey("goBackPortal", queryParams?.portal);
        setKey("goBackUrl", queryParams?.referrer && decodeURIComponent(queryParams?.referrer));
        updateComponentParams(dispatch, 'layout-passport', { 'showTerms': 'NO' })
        setKey("showTerms", "NO");

        //update http client for custom headers
        HttpClient.updateClient();
        getUserInfo();
    }
    
    /**
    * function to set sso login value
    */
    const setSSOUser = () => {
        if (params?.token) {
            setLocalStorage('proxyToken', params?.token)
            queryParams = window.atob(params['token']);
        }
        try {
            queryParams = JSON.parse(queryParams)
        } catch (e: any) {
            Logger.error("KeycloakPostLogin.tsx", "error", e);
         }
        updateComponentParams(dispatch, 'app-global-store', { 'theme': 'mxm' })
        setLocalStorage("MXMSsoLogin", true);
        setKey("goBackPortal", 'MXM');
        setKey("goBackUrl", queryParams?.referrer && decodeURIComponent(queryParams?.referrer));
        setKey("goPriorityCapitalUrl", queryParams?.redirectPath && decodeURIComponent(queryParams?.redirectPath));
        updateComponentParams(dispatch, 'layout-passport', { 'showTerms': 'NO' })
        setKey("showTerms", "NO");
        getUserInfo();
    }

    const settingsReq: any = {
        "criteria": {
            "filters": [
                {
                    "operator": "in",
                    "key": "settingName",
                    "values": [
                        "ALLOW_CORPORATE_PHYSICAL_DEBIT_CARD_ISSUANCE",
                        "ALLOW_COLLECT_WITH_SOURCE_DETAILS",
                        "MANDATE_CARD_INFO_FOR_CARD_TRANSACTION",
                        "ALLOWED_METHODS_IN_PPI",
                        "ALLOW_SEND_VIA_VIRTUAL_CARD",
                        "ALLOW_CONSUMER_PHYSICAL_DEBIT_CARD_ISSUANCE",
                        "APPLY_NEW_CARD_STATUS_LIFECYCLE",
                        "INTERNAL_PROGRAM_MANAGER",
                        "DISPLAY_RETURN_FEE",
                        "ALLOW_NON_TAX_IDENTIFIER_ONBOARDING",
                        "ENABLE_BATCH_RECON_VIEW",
                        'AUTO_ISSUANCE_DEBIT_CARD_BUSINESS',
                        'AUTO_ISSUANCE_DEBIT_CARD_INDIVIDUAL',
                        'AUTO_ISSUANCE_DEBIT_CARD_JOINT_TENANCY',
                        'DISABLE_SUBTOTAL_RULE_CREATION',
                        'ENFORCE_TRANSACTION_MFA',
                        'ENABLE_ISSUANCE_WITH_UNIFIED_CARD_PROGRAM',
                        'NOTIFICATION_BANNER_ENABLED',
                        'NOTIFICATION_BANNER_TITLE',
                        'NOTIFICATION_BANNER_MESSAGE',
                        'NOTIFICATION_BANNER_POPUP_MESSAGE'
                    ]
                }
            ]
        }
    }

    const themeSettingsRequest: any = {
        "criteria": {
            "filters": [
                {
                    "operator": "in",
                    "key": "settingName",
                    "values": [
                        "CUSTOMER_PORTAL_THEME"
                    ]
                }
            ]
        }
    }
    

    const listRequest =
    {
        "pageSize": 25,
        "pageNumber": 1,
        "sortOptions": {
            "sortOrder": "DESC",
            "sortBy": "createdOn"
        },
        criteria: {
            filters: []
        }
    };

    const quick_settle_settings_request = {
        "pageNumber": 1,
        "pageSize": 1,
        "sortOptions": {
            "sortBy": "lastUpdatedOn",
            "sortOrder": "desc"
        },
        "criteria": {
            "filters": [
                {
                    "operator": "eq",
                    "key": "category",
                    "values": [
                        "QUICK_SETTLE"
                    ]
                },
                {
                    "operator": "in",
                    "key": "entityName",
                    "values": [
                        "ACCOUNT", "MERCHANT"
                    ]
                }

            ]
        }
    }    

    const merchant_request = {
        pageNumber: 1,
        pageSize: 25,
        criteria: {
            filters: []
        }
    }

    useEffect(() => {
        const count = props.accountList?.totalCount;
        if (typeof count !== 'number') {
          // nothing to do until we know the account count
          return;
        }
      
        // mark whether we're in the signup flow
        let inSignUpFlow = count === 0;
        // checking customer is Joint Tenancy CoOwner and  KYC is not completed
        if(getParsedLocalStorage('userType')===CustomerType.JOINT_TENANCY && getKey('isPrimaryOwner') === false && getKey('accountAgreementAccepted')===false){
            inSignUpFlow=true;
        }

        setLocalStorage('signUpFlow', inSignUpFlow);
      
        // if user already has accounts, we’re done
        if (!inSignUpFlow) {
          return;
        }
      
        // grab all the values we need exactly once
        const userType  = getParsedLocalStorage('userType');
        const loginType = getKey('loginType');
        const partnerAccepted = Boolean(getKey('partnerPolicyAccepted'));
        const rawRoute = getLocalStorage('kycRedirectionRoute') || '';
        // strip quotes and leading slashes
        const savedRoute = rawRoute.replace(/^"+|"+$/g, '').replace(/^\/+/, '');
        const navigateTo = (route: string) => {
          setLocalStorage('kycRedirectionRoute', route);
          history.push(route);
        };
        if(getKey('showTerms') !== 'YES'){
        switch (userType) {
          case 'BUSINESS':
            if (loginType === 'PARTNER'&& savedRoute !== 'signup/business/kyc') {
              if (partnerAccepted) {
                // partner already accepted and not landing on KYC
                setLocalStorage('signUpFlow', false);
                history.push('/leads-home');
              } else {
                setLocalStorage('kycRedirectionRoute', '/signup/partner/welcome');
                history.push('/signup/partner/welcome');
              }
            } else{
                navigateTo('/signup/business/kyc');
            
            }
            break;
      
          case 'INDIVIDUAL':
            navigateTo('/signup/individual/kyc');
            break;
      
          case 'JOINT_TENANCY':
            const isJTCOwner = getKey('isPrimaryOwner') === false;
            const url = isJTCOwner ? '/signup/joint_tenancy_co_owner/kyc' : '/signup/joint_tenancy/kyc';
            navigateTo(url);
            break;
      
          default:
            Logger.warn('Unhandled sign-up userType:', userType);
        }
        }
      }, [props.accountList?.totalCount, history]);
  /**
     * Method used to get user informations from API
     * @returns :user information
     */
    async function getUserInfo() {
        try {
            // Reset notification banner state before PM settings are re-fetched
            clearNotificationBannerSettingsLoaded();
            FxTopBanner.closeForce(MAINTENANCE_BANNER_ID);
            let userTypeData: any;
            let accountList: any;
            let pmSettings: any;
            let sessionData: any;
            let quickSettleSettings: any;
            let readMeToken: any;
            let customerConfigurations: any;
            let customerMerchantWhenProxyLogin: any;
            let associatedCustomerNameList: any;
            let associated_customers_request: any;
            let hasInvestmentAccount: boolean = false;
            let hasCashBuilderAccount:boolean = false;
            let responseSettings:any;
            dispatch({ type: "DATA_COMPONENT_INIT", payload: { id: 'keycloak-loader' } });
            try {
                responseSettings = await getPMProcessingSettings();
            } catch (error: any) {
                if (error?.response?.status) {
                    const errorCode = error?.response?.status;
                    history.push(`/user/unauthorized/${errorCode}`)
                    Logger.error("KeycloakPostLogin", "error", error);
                    return null;
                }
            }
            const customerSettings = responseSettings?.data;
            //PM level setting used to check the theme set Per PM, default will be “customer orange theme”
            const pmSettingValue = getPmSettingsValue(customerSettings, "CUSTOMER_PORTAL_THEME");
            setLocalStorage("customerTheme", pmSettingValue)
            if(queryParams?.portal!=='CSG' &&  queryParams?.portal!=='PM'){
                if( mxmUser && !ssoPath && (pmSettingValue !== ThemeEnum.ORANGE_THEME)){
                    updateComponentParams(dispatch, 'app-global-store', { 'theme': 'mxm' })
                }
                const apiUrl: any = queryParams?.xmid ? 'profile/mid/' + queryParams?.xmid : 'profile';
                const profileData = await httpClient.get(apiUrl).then(response => {
                    setKey("permissionDenied", 'False');
                    return response.data
                }).catch(error => {
                    setKey("permissionDenied", 'True');
                    return { ...error };
                })

                /**
                 * if the response is 401 then it should be redirected into login page
                 */
                if(profileData && profileData?.response?.status===401){
                    FxSnackBar.show({
                        autoHideDuration: 3000,
                        severity: 'error',
                        text: profileData?.response?.data?.errorMessage
                    });
                    setTimeout(() => {
                        history.push("/logout");
                      }, 3000); 
                }

                //If profile details available settings user based keys
                if (profileData) {
                    updateComponentParams(dispatch, 'keycloak-loader', { 'skipLoader': true});
                    userDetails(profileData?.id)
                    setKey('firstName', profileData.firstName);
                    setKey('loginType', profileData.userType);
                    setKey("id", profileData?.id);
                    setKey("countryCode", profileData?.countryCode);
                    setKey("email", profileData?.email);
                    customerEmail=profileData?.email;
                    setKey("lastName", profileData?.lastName);
                    setKey("phone", profileData?.phone);
                    setKey("userName", profileData?.userName);
                    setKey('partnerId',profileData?.customer[0]?.programAffiliate?.id);
                    setKey("customerInitialMerchantId",profileData?.customer?.[0]?.merchant?.[0]?.id);
                    setKey('partnerPolicyAccepted', profileData?.customer?.[0]?.programAffiliate?.partnerAgreementAccepted);
                    setKey("invitationType",profileData?.customer?.[0]?.onboardedVia)
                    // configuring user details in the full story
                    const fullStoryProperties = {
                        displayName: `${profileData.firstName || ''} ${profileData.lastName || ''}`.trim(),
                        email: profileData?.email,
                        userName: profileData?.userName,
                        userId: profileData?.id,
                        phone: profileData?.phone,
                        signUpDate: new Date().toISOString()
                    };
                    const userIdentificationParam:any={
                        uid:profileData?.id,
                        properties:{
                            displayName:`${profileData.firstName || ''} ${profileData.lastName || ''}`.trim(),
                            email: profileData?.email,
                        }
                    }
                    setFullStoryProperties('user',fullStoryProperties)
                    userIdentification(userIdentificationParam)
                    if(!JSON.parse(getLocalStorage('MXMSsoLogin'))){
                        dispatch({ type: "DATA_COMPONENT_INIT", payload: { id: 'layout-passport' } });
                        setKey("showTerms", (profileData?.privacyPolicyAccepted === true) ? 'NO' : 'YES');
                        updateComponentParams(dispatch, 'layout-passport', { 'showTerms': (profileData?.privacyPolicyAccepted === true) ? 'NO' : 'YES' })
                    }
                    setLocalStorage("userType", String(profileData?.customer?.[0]?.subType)||'');
                    customerId = getDefaultCustomer(profileData?.customer, queryParams?.xmid)?.id || getKey('customerId');
                    const customer = profileData?.customer?.find((item: any) => item.id === customerId);
                    setKey("authUserId", customer?.authorizedUser?.id);
                    setKey("accountAgreementAccepted", customer?.authorizedUser?.accountAgreementAccepted);
                    setKey("isPrimaryOwner", customer?.authorizedUser?.isPrimaryOwner);
                    setKey('showBatch', customer?.merchant?.length > 0)
                    setKey("customerId", customerId);
                    setLocalStorage("permission", profileData?.customer?.[0]?.permissions)
                    setKey("programManagerId",profileData?.customer?.[0]?.programManagerId)

                    if(profileData?.customer?.[0]?.role?.some((item:any) => item.isGlobalEntityAccess === true && item.isGlobalObjectAccess === true)){
                        setKey('role','ADMIN');
                    }else{
                        setKey('role','NON_ADMIN');
                    }
                    //adding two key for quick start page
                    const hasDashBoardExternalAccount=profileData?.customer?.[0]?.externalAccount?.hasExternalAccount ;
                    const hasTransaction = profileData?.customer?.[0]?.hasTransaction ;
                    setKey('hasTransaction', hasTransaction);
                    if(hasDashBoardExternalAccount){
                        const dashboardExternalAccountId = profileData?.customer?.[0]?.externalAccount?.id;
                        const dashBoardExternalAccountNumber=profileData?.customer?.[0]?.externalAccount?.accountNumber;
                        const dashboardEAVerificationStatus = profileData?.customer?.[0]?.externalAccount?.validationStatus?.toLowerCase();
                        setKey('dashboardExternalAccountId', dashboardExternalAccountId); 
                        setKey('dashBoardExternalAccountNumber', dashBoardExternalAccountNumber);
                        setKey('dashboardEAVerificationStatus', dashboardEAVerificationStatus);
                        const allowedStatuses = ['pending', 'awaiting_verification', 'processing'];
                        const isAllowedStatus = allowedStatuses.includes(dashboardEAVerificationStatus);
                        if(!isNullOrUndefined(getKey('dashboardExternalAccountId'))){
                            setKey('gsq_add_external_account_status', 'completed');
                            if(dashboardEAVerificationStatus === 'completed'){
                                setKey('gsq_verify_external_account_status', 'completed');
                            }
                        }
                    }

                //request for the associated customer list API for Multiple EIN Customer usecase
                associated_customers_request = {
                    pageNumber: 1,
                    pageSize: 10,
                    sortOptions: { sortBy: "id", sortOrder: "asc" },
                    criteria: {
                        filters: [
                        { key: "userId", operator: "eq", values: [profileData?.id] },
                        ],
                    },
                };
                }

            }
            const shouldSkipLoader = isCsgOrPmPortal(queryParams?.portal);

            if (shouldSkipLoader) {
                updateComponentParams(dispatch, 'keycloak-loader', { skipLoader: true });
            }

            //Calling multiple API's od customer when loggedIn succesfully
            const result = await Promise.allSettled([getSession(), getCustomerDetails(), getUserAccount(), getProcessingSettings(), getQuickSettleSettings(), getReadmeToken(customerEmail), getCustomerConfiguration(), getCustomerMerchantWhenProxyLogin(), getAssociatedCustomersList(associated_customers_request)]).then(function (data: any) {
                if (data?.[0]?.status === "fulfilled") {
                    sessionData = data?.[0]?.value?.data
                } if (data?.[1]?.status === "fulfilled") {
                    userTypeData = data?.[1]?.value?.data
                } if (data?.[2]?.status === "fulfilled") {
                    _.isNull(isUserRefreshed) && dispatch({ type: "DATA_COMPONENT_INIT", payload: { id: 'customer-basic-info' } });
                    _.isNull(isUserRefreshed) && dispatch({ type: "DATA_COMPONENT_INIT", payload: { id: 'customer-basic-info-cb-cbplus' } });
                    updateComponentParams(dispatch, "customer-basic-info", { 'accountList': data?.[2]?.value?.data })
                    accountList = data?.[2]?.value?.data
                } if (data?.[3]?.status === "fulfilled") {
                    pmSettings = data?.[3]?.value?.data
                } if (data?.[4]?.status === "fulfilled") {
                    quickSettleSettings = data?.[4]?.value?.data
                } if (data?.[5]?.status === "fulfilled") {
                    readMeToken = data?.[5]?.value?.data?.jwtToken
                } if (data?.[6]?.status === "fulfilled") {
                    customerConfigurations = data?.[6]?.value?.data
                } if (data?.[7]?.status === "fulfilled") {
                    customerMerchantWhenProxyLogin = data?.[7]?.value?.data
                } if (data?.[8]?.status === "fulfilled") {
                    associatedCustomerNameList = data?.[8]?.value?.data
                }

                if (accountList && accountList.totalCount >= 1) {
                    updateComponentParams(dispatch, "customer-basic-info-cb-cbplus", { 'fullAccountList': data?.[2]?.value?.data })
                }

                //Updating the customer list property inthe switch-customer-menu component with the updated list of Customers
                updateComponentParams(dispatch, "switch-customer-menu", { customerList: associatedCustomerNameList?.resources });

                if (readMeToken) {
                    setKey("readMeToken", readMeToken);
                }
                if (getKey("isProxyLogin")) {
                    setKey('showBatch', customerMerchantWhenProxyLogin?.resources?.length > 0)
                }

                const passportAgreementUrl = getCustomerConfigurationValue(customerConfigurations, 'PASSPORT_ACCOUNT_AGREEMENTS');                    
                const rateCardUrl = getCustomerConfigurationValue(customerConfigurations, 'PASSPORT_CONSUMER_DEPOSIT_ACCOUNT_RATE_CARD');                    
                setKey('passportAgreementUrl',passportAgreementUrl);
                setKey('rateCardUrl',rateCardUrl);
                
                const enableTargetBalanceAccount = gethierarchyLevelConfigurationValue(customerConfigurations, 'ENABLE_TARGET_BALANCE_ACCOUNT','CUSTOMER');                    
                setKey('enableTargetBalanceAccount', enableTargetBalanceAccount === '1' || enableTargetBalanceAccount?.toLowerCase() === 'true' ? 'true':'false');
                
                const enableNachaFilemanagement = gethierarchyLevelConfigurationValue(customerConfigurations, 'NACHA_FILE_UPLOAD','PROGRAM_MANAGER');                    
                setKey('enableNachaFilemanagement', enableNachaFilemanagement?.toLowerCase() === 'true' ? 'true':'false');

                const enableNachaFileUploadForCustomers = getCustomerConfigurationValue(customerConfigurations, 'ENABLE_NACHA_FILE_UPLOAD_FOR_CUSTOMERS');                    
                setKey('enableNachaFileUploadForCustomers', enableNachaFileUploadForCustomers === '1' || enableNachaFileUploadForCustomers?.toLowerCase() === 'true' ? 'true':'false');

                 const nachaCutOffTiming = gethierarchyLevelConfigurationValue(customerConfigurations, 'CUTOFF_TIMINGS','ADMIN');                    
                setKey('nachaCutOffTiming', nachaCutOffTiming || '15:30');
  
                const effectiveEntryDays = gethierarchyLevelConfigurationValue(customerConfigurations, 'MAX_TRANSACTION_CREATION_LEAD_DAYS','ADMIN');                    
                setKey('effectiveEntryDays', effectiveEntryDays || '60');

                

                const enableInvestmentAccount = getCustomerConfigurationValue(customerConfigurations, 'ENABLE_CASH_BUILDER_ACCOUNT');                    
                setKey('enableInvestmentAccount', enableInvestmentAccount === '1' || enableInvestmentAccount?.toLowerCase() === 'true' ? 'true':'false');
                
                const enableCashBuilderAccount = getCustomerConfigurationValue(customerConfigurations, 'ENABLE_CASH_BUILDER_PLUS_ACCOUNT');                    
                setKey('enableCashBuilderAccount', enableCashBuilderAccount === '1' || enableCashBuilderAccount?.toLowerCase() === 'true' ? 'true':'false');
                const cashBuilderPlusInvestmentMode = getCustomerConfigurationValue(customerConfigurations, 'CASH_BUILDER_PLUS_INVESTMENT_VENDOR');                
                setKey('cashBuilderPlusInvestmentMode', cashBuilderPlusInvestmentMode);

                const cashBuilderInterestRate = getCustomerConfigurationValue(customerConfigurations, 'CASH_BUILDER_INTEREST_RATE');                   
                setKey('cashBuilderInterestRate', cashBuilderInterestRate + '%');

                const cashBuilderPlusInterestRate = getCustomerConfigurationValue(customerConfigurations, 'CASH_BUILDER_PLUS_TIER_2_INTEREST_RATE');                    
                setKey('cashBuilderPlusInterestRate', cashBuilderPlusInterestRate + '%');
                
                const collectAchControl = getCustomerConfigurationValue(customerConfigurations, 'ALLOW_ACH_COLLECT');   
                setKey('collectAchControl', collectAchControl);

                const accountAgreementConfigurations = getCustomerConfigurationsByCategory(customerConfigurations, 'ACCOUNT');
                const debitCardAgreementConfigurations = getCustomerConfigurationsByCategory(customerConfigurations, 'DEBIT_CARD_CONFIGURATION_ENUM');
                const merchantAgreementConfigurations = getCustomerConfigurationsByCategory(customerConfigurations, 'MERCHANT');
                setKey('accountAgreementConfigurations', accountAgreementConfigurations);
                setKey('debitCardAgreementConfigurations', debitCardAgreementConfigurations);
                setKey('merchantAgreementConfigurations', merchantAgreementConfigurations);

                const enableFundingRule = getCustomerConfigurationValue(customerConfigurations, checkIsPartner()? "SHOW_FUNDING_RULE_PARTNER_PORTAL" :"SHOW_FUNDING_RULE_CUSTOMER_PORTAL");  
                setKey('enableFundingRule', enableFundingRule === '1' ? 'true' : 'false');

                setKey("isCardQuickSettleEnabled", getQuickSettleValue(quickSettleSettings,'COLLECT_CARD_QUICK_SETTLE'));
                setKey("isAchQuickSettleEnabled", getQuickSettleValue(quickSettleSettings,'COLLECT_ACH_QUICK_SETTLE'));
                setKey("isCheckQuickSettleEnabled", getQuickSettleValue(quickSettleSettings,'COLLECT_CHECK_QUICK_SETTLE'));
                
                setKey("isIssueDebitCardBusinessAllowed", getPmSettingsValue(pmSettings, "ALLOW_CORPORATE_PHYSICAL_DEBIT_CARD_ISSUANCE"));
                setKey("isIssueDebitCardIndividualAllowed", getPmSettingsValue(pmSettings, "ALLOW_CONSUMER_PHYSICAL_DEBIT_CARD_ISSUANCE"));
                setKey('ppiSupportedMethods', getPmSettingsValue(pmSettings, "ALLOWED_METHODS_IN_PPI"))
                setKey('oneTimeAllowed', getPmSettingsValue(pmSettings,"ALLOW_COLLECT_WITH_SOURCE_DETAILS"))
                setKey('sendViaVirtualMethod', getPmSettingsValue(pmSettings, 'ALLOW_SEND_VIA_VIRTUAL_CARD'))
                setKey("mandateFieldForCardTransaction", getPmSettingsValue(pmSettings, 'MANDATE_CARD_INFO_FOR_CARD_TRANSACTION'))
                setKey("isNewCardStatusLifecycleApplied", getPmSettingsValue(pmSettings, 'APPLY_NEW_CARD_STATUS_LIFECYCLE'))
                setKey("isEnableBatchView", getPmSettingsValue(pmSettings, 'ENABLE_BATCH_RECON_VIEW'))
                setKey("isInternalPMSettingEnabled", getPmSettingsValue(pmSettings,'INTERNAL_PROGRAM_MANAGER'));
                setKey("displayReturnFee", (getPmSettingsValue(pmSettings,'DISPLAY_RETURN_FEE')));
                setKey("allowNontaxIdentifierOnboarding", (getPmSettingsValue(pmSettings,'ALLOW_NON_TAX_IDENTIFIER_ONBOARDING')));

                setKey("autoIssueBusinessDebitCards", (getPmSettingsValue(pmSettings,'AUTO_ISSUANCE_DEBIT_CARD_BUSINESS')));
                setKey("autoIssueIndividualDebitCards", (getPmSettingsValue(pmSettings,'AUTO_ISSUANCE_DEBIT_CARD_INDIVIDUAL')));
                setKey("autoIssueJointTenancyDebitCards", (getPmSettingsValue(pmSettings,'AUTO_ISSUANCE_DEBIT_CARD_JOINT_TENANCY')));

                setKey("isSubtotalRuleCreationDisabled", (getPmSettingsValue(pmSettings,'DISABLE_SUBTOTAL_RULE_CREATION')));
                setKey("enforceTransactionMfa", (getPmSettingsValue(pmSettings,'ENFORCE_TRANSACTION_MFA')).toUpperCase());
                setKey("isIssuanceWithUnifiedCardProgramEnabled", (getPmSettingsValue(pmSettings,'ENABLE_ISSUANCE_WITH_UNIFIED_CARD_PROGRAM')));
                // Persist notification banner PM settings to appStorage for MaintenanceBanner + carousel gating
                applyNotificationBannerSettings(pmSettings);

                const mxcWhitelistedUsersList = getCustomerConfigurationValue(customerConfigurations,"MXC_WHITELISTED_USERS");
                setKey("mxcWhitelistedUsersList", mxcWhitelistedUsersList);

                setKey("sessionToken", sessionData);
                if (!sessionData) {
                    return false;
                }
                setKey('isPPIEnabled', 'TRUE')
                
                if (customerConfigurations) {
                    const transactionAprovalValue = getCustomerConfigurationValue(customerConfigurations, 'TRANSACTION_APPROVAL');
                    const enableBillPaymentVisible = getCustomerConfigurationValue(customerConfigurations, 'ALLOW_MONEYGRAM_TRANSACTION');
                    setKey('isTransactionApprovalEnabled', transactionAprovalValue === '1' || transactionAprovalValue?.toLowerCase() === 'true' ? 'true':'false');

                    if(enableBillPaymentVisible) {
                        setKey('isEnableBillPaymentVisible', enableBillPaymentVisible === '1' || enableBillPaymentVisible?.toLowerCase() === 'true' ? 'true':'false');
                    }
                }

                if (accountList && accountList.totalCount > 1) {
                    setKey("verificationStatus", 'true');
                    setKey("accountStatus", 'true');
                    if(accountList?.resources.find((x:any)=>x.type === 'CASH_BUILDER')){
                        // Set hasInvestmentAccount flag as true to check current user have investment account or not
                        hasInvestmentAccount = true;
                    }
                    if(accountList?.resources.find((x:any)=>x.type === 'CASH_BUILDER_PLUS')){
                        // Set hasCashBuilderAccount flag as true to check current user have Cash Builder+ account or not
                        hasCashBuilderAccount = true;
                    }
                }
                else if (accountList && accountList.totalCount === 1 && accountList?.resources[0]?.status === 'ACTIVE') {
                    setKey("accountStatus", 'true');
                }
                else {
                    setKey("accountStatus", 'false');
                }
                setKey("customerInitialAccount",accountList?.resources?.[0] );
                /**
                 * setting other varibales in storage which is used in regular login flow
                 */
                if (userTypeData?.type) {
                    setLocalStorage("userType", userTypeData?.type||'');
                }
                const authorizedBo = userTypeData?.business?.beneficialOwner;
                if (authorizedBo && Array.isArray(authorizedBo)) {
                    const result = authorizedBo?.find((obj:any) => obj.actAsAuthorizedSignatory === true);
                    setKey("authorizedUserBO", result);
                }
                if (userTypeData?.status) {
                    setKey("customerStatus", userTypeData?.status);
                }
                if (userTypeData?.type === 'BUSINESS') {
                    setKey('mxmFastFunding',true);
                    setKey('doingBusinessAs', userTypeData?.business?.doingBusinessAs)
                    setKey("CustomerName", userTypeData?.business?.legalName);
                    setKey("businessCategory", userTypeData?.business?.businessCategory);
                    setVerificationStatus(userTypeData?.business?.verification);

                    //Setting the primary mailing address of Authorized User
                    const authorizedUsers = userTypeData?.business?.beneficialOwner?.filter(
                        (user: any) => user?.actAsAuthorizedSignatory
                    );
                    const primaryAddress = authorizedUsers?.[0]?.mailingAddress?.find(
                        (address: any) => address?.isPrimary
                    );
                    setKey("PhysicalCardAddress", primaryAddress || null);
                }

                else if (userTypeData?.type === 'INDIVIDUAL') {
                    setKey("CustomerIndividualFullName", userTypeData?.individual?.fullName);
                    setVerificationStatus(userTypeData?.individual?.verification);
                    setKey("PhysicalCardAddress",userTypeData?.individual?.mailingAddress?.[0]);
                    setKey("SSN",userTypeData?.individual?.last4ssn || '');
                }

                else if (userTypeData?.type === 'JOINT_TENANCY') {
                  const authUserId = getKey("authUserId");
                  const customer = userTypeData.owners?.find((item: any) => item.id === authUserId);
                  const primaryOwner = userTypeData.owners?.find((item: any) => item.isPrimaryOwner);
                  setKey("CustomerIndividualFullName", customer?.fullName);
                  setKey("PrimaryOwnerFullName", primaryOwner?.fullName);
                  setKey("LoggedInOwnerId", customer?.id);
                  setVerificationStatus(userTypeData?.verification);
                
                // Fetches the primary mailing address(es) of the primary owner.
                // It filters the list of owners to find those marked as isPrimaryOwner,
                // then collects their mailing addresses that are marked as isPrimary.
                const filteredArray = Array.isArray(userTypeData?.owners)
                    ? userTypeData.owners
                        .filter((owner: any) => owner?.isPrimaryOwner && Array.isArray(owner.mailingAddress))
                        .flatMap((owner: any) =>
                            owner.mailingAddress.filter((address: any) => address?.isPrimary)
                        )
                    : [];
                
                setKey("PhysicalCardAddress",filteredArray[0]);
                }

                setKey("isUserDetailsAvailable", 'TRUE');
                getKYCDetails(accountList);
                updateComponentParams(dispatch, 'keycloak-post-login', { 'skipSkeleton': true, 'accountList': accountList, 'customerConfigurations': customerConfigurations, 'allSettled': true, customerId });
            }).catch(error => {
                return { ...error };
            })

            //Set PPI Details
            const ppiDetails = await httpClient.get(getCustomerUrl('/ppi'));

            //Used to set params and dispatch only once to redux
            const params:any = {};
            if (hasInvestmentAccount) params.hasInvestmentAccount = true;
            if (hasCashBuilderAccount) params.hasCashBuilderAccount = true;
            if (ppiDetails) params.ppiDetails = ppiDetails?.data
            if (Object.keys(params).length) {
                updateComponentParams(dispatch, "customer-basic-info", params);
            }
            //uiFeat.
            return result
        } catch (error:any) {
            Logger.error("KeycloakPostLogin", "error", error);
            return null;
        }
    }

    /**
     * Function to get the Associated Customers List.
     */
    async function getAssociatedCustomersList(requestBody: any) {
        const userId = requestBody?.criteria?.filters?.find(
            (f: any) => f.key === "userId"
        )?.values?.[0];

        // If userId is null or undefined → skip API call
        if (isNullOrUndefined(userId)) {
            return Promise.resolve(null);
        }
        return await httpClient.post(
            getCustomerUrl("user/associatedCustomers", true),
            requestBody
        );
    }
   
    
    /**
     * function to get session data from API
     * @returns data
     */
    function getSession() {
        return httpClient.get('/secure/sessiontoken');
    }
    /**
     * function to get account list from API
     * @returns data
     */
    function getUserAccount() {
        return httpClient.post('customer/id/' + customerId + '/account/list', listRequest);
    }

   /**
     * function to get readMe token from API
     * @returns data
     */
   function getReadmeToken(userName:any) {
    const readMelistRequest = {
        name:   userName,
        email:  userName,
        allowedProjects: readMeConfig['projects'], 
        apikey: readMeConfig['api_key'] ,
        version:  1
    }
    return httpClient.post('user/readmeToken', readMelistRequest);
  }

    /**
     * function to get processing settings data from API
     * @returns data
     */
    function getProcessingSettings() {
        return httpClient.post('programManager/getProgramManagerSetting', settingsReq);
    }
       /**
     * function to get processing settings data from API
     * @returns data
     */
       function getPMProcessingSettings() {
        return httpClient.post('programManager/getProgramManagerSetting', themeSettingsRequest);
    }
    /**
     * function to get customer data from API
     * @returns data
     */
    function getCustomerDetails() {
        return httpClient.get('customer/id/' + customerId);
    }

    /**
     * function to get PM level's quick settle settings data from API
     * @returns data
     */
    function getQuickSettleSettings() {
        return httpClient.post(`programManager/configuration/list`, quick_settle_settings_request);
    }

    /**
     * Function to check account status
     * @param accountList :account info
     */
    function getKYCDetails(accountList: any) {
        if (accountList && accountList.totalCount === 0) {
            setKey("customerKYC", 'continue');
        }
        else if (accountList && accountList.totalCount === 1 && accountList?.resources[0]?.status === 'INACTIVE') {
            setKey("customerKYC", 'stepper');
        }
        else {
            setKey("customerKYC", 'skip');
        }
    }

    /**
    * Function to get program manager setting value
    * @param data :settings data
    * @param settingName :settings name
    * @returns
    */
    function getPmSettingsValue(data: any, settingName: string) {
        const value = data?.resources?.find((x: any) => x.settingName === settingName)
        return value?.settingValue ?? value?.defaultValue;
    }     

    /**
     * Function to get customer configuraion value
     * @param data :merchant data
     * @param settingName :setting name
     * @returns
     */
      function getCustomerConfigurationValue(data:any, settingName: string) {
        const value = data?.resources?.find((x:any)=> x.name === settingName)

        return value?.value;
    }

    /**
     * Function to check hierarchyLevel in the configuraion value
     * @param data :setting data
     * @param settingName :setting name
     * @param hierarchyLevel :hierarchy Level
     * @returns
     */
        function gethierarchyLevelConfigurationValue(data:any, settingName: string, hierarchyLevel : string) {
            const value = data?.resources?.find((x:any)=> x.name === settingName && x.hierarchyLevel === hierarchyLevel)
    
            return value?.value;
        }

        

  /**
   * Function to get customer configurations by category
   * @param data :configuration data
   * @param categoryName :category name
   * @returns filtered configurations
   */
  function getCustomerConfigurationsByCategory(data:any, categoryName: string) {
    return data?.resources?.filter((x:any)=> x.category === categoryName);
  }

    /**
     * Function to get quick settle value
     */
    function getQuickSettleValue(data:any, name: string) {
        return !!Number(data?.resources?.find((item:any)=> item.name === name)?.value);
    }

     /**
     * function to get customer configuration value
     * @returns data
     */
       function getCustomerConfiguration() {
        return httpClient.get('customer/id/' + customerId + '/configuration');
    }

    /**
     * function to get customer merchant
     * @returns data
     */
    function getCustomerMerchantWhenProxyLogin() {
        return getKey("isProxyLogin") ? httpClient.post(getCustomerUrl("/merchant/list", false), merchant_request) : [];
    }

    

    return (
        <DashboardSkeleton />
    )
};
